<template>
  <div class="bg-white" :class="UI.isMobile ? 'padding-xs' : 'padding'">
    <div class="flex justify-center align-center"><h3>首页轮播图管理</h3></div>

    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column label="图片(3:1)">
        <template slot-scope="scope">
          <img :src="scope.row.src" />
        </template>
      </el-table-column>

      <el-table-column prop="sort" label="排序"></el-table-column>
      <el-table-column label="关联链接">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank">
            {{ scope.row.url ? '点击预览' : '无' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="180">
        <template slot="header" slot-scope="scope">
          <el-button
            @click="
              headPicInfo = {};
              isShow = true;
            "
            type="primary"
            size="small"
          >
            发布轮播图
          </el-button>
        </template>
        <template slot-scope="scope">
          <el-button
            @click="
              headPicInfo = scope.row;
              isShow = true;
            "
            type="primary"
            size="small"
          >
            编辑
          </el-button>
          <el-button
            @click="handleDeleteHeadPic(scope.row.id)"
            type="danger"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      title="发布轮播图"
      :visible.sync="isShow"
      width="800px"
      show-close
      v-if="isShow"
      :fullscreen="UI.isMobile"
    >
      <div class="flex flex-direction align-center headPicInfo">
        <el-form
          ref="headPicInfoForm"
          :model="headPicInfo"
          :rules="headPicInfoRules"
          :label-position="UI.isMobile ? 'top' : 'left'"
          :label-width="UI.isMobile ? undefined : '120px'"
          style="width: 90%;"
        >
          <el-form-item label="标题" prop="title">
            <el-input
              placeholder="请输入标题"
              clearable
              v-model="headPicInfo.title"
            ></el-input>
          </el-form-item>

          <el-form-item label="排序" prop="sort">
            <el-input-number
              placeholder="请输入排序"
              clearable
              :min="0"
              :max="9999"
              v-model="headPicInfo.sort"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="图片" prop="src">
            <MediaUpload
              ref="src"
              :action="uploadUrl + '/upload/head_pic'"
              :suffixList="[]"
              :file="headPicInfo.src"
              @success="handlerUploadSuccess('src')"
            ></MediaUpload>
          </el-form-item>
          
          <el-form-item label="关联链接" prop="url">
            <el-input
              placeholder="请输入关联链接"
              clearable
              v-model="headPicInfo.url"
            ></el-input>
          </el-form-item>
        </el-form>

        <el-button
          class="login-button padding-xs margin-top"
          type="primary"
          size="mini"
          @click="submit()"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getHeadPicList, addHeadPic, deleteHeadPic } from '@/servers/admin.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import { baseUrl } from '@/utils/consts.js';
import MediaUpload from '@/components/upload/mediaUpload.vue';

export default {
  components: {
    MediaUpload,
  },

  data() {
    return {
      uploadUrl: baseUrl,
      headPicInfo: {},
      isShow: false,
      total: 0,
      tableData: [],
      filterForm: {
        page: 1,
        page_size: 10,
      },
      headPicInfoRules: {
        title: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        src: [
          {
            required: true,
            message: '请输入描述',
            trigger: 'blur',
          },
        ],
        sort: [
          {
            required: true,
            message: '请输入排序',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {
    flushData: function() {
      let that = this;
      this.page = 1;
      getHeadPicList(this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    handlerUploadSuccess: function(key) {
      this.headPicInfo[key] = this.$refs[key].uploadRes;
    },

    handleDeleteHeadPic: function(headPicId) {
      let that = this;
      this.$confirm('确认删除(记录)?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          deleteHeadPic(headPicId, function(res) {
            showSuccessMsg(res);
            that.flushData();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消',
          });
        });
    },

    submit: function() {
      let that = this;
      this.$refs.headPicInfoForm.validate((valid) => {
        if (valid) {
          addHeadPic(this.headPicInfo, function(res) {
            that.headPicInfo = {};
            that.isShow = false;
            that.flushData();
            showSuccessMsg(res);
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/homepage/headPic.vue